import { FormField } from 'src/common/FormField';
import { FormContextField } from 'src/common/FormField/FormContextField';

export default function TransportationSettings() {
  return (
    <div className="grid grid-cols-1 gap-x-4 gap-y-4 border-b border-gray-900/10 py-5 md:grid-cols-4">
      <div>
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          Transportation
        </h2>
        <p className="mt-1 text-sm leading-6 text-gray-600">
          Organization defaults for transportation.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-4 md:col-span-3">
        <div>
          <FormContextField name="standard_transport_time_start">
            {({ field, fieldState }) => {
              return (
                <FormField
                  label="Transport Start Time"
                  error={fieldState.error?.message?.toString()}
                  type="time"
                  inputProps={{
                    id: 'transport_start_time',
                    ...field,
                    'data-testid': 'transport_start_time',
                  }}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={field.value}
                />
              );
            }}
          </FormContextField>
        </div>
        <div>
          <FormContextField name="standard_transport_time_end">
            {({ field, fieldState }) => {
              return (
                <FormField
                  label="Transport End Time"
                  error={fieldState.error?.message?.toString()}
                  type="time"
                  inputProps={{
                    id: 'transport_end_time',
                    ...field,
                    'data-testid': 'transport_end_time',
                  }}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={field.value}
                />
              );
            }}
          </FormContextField>
        </div>
        <div className="flex items-center">
          <FormContextField name="should_avoid_toll_roads">
            {({ field, fieldState }) => {
              return (
                <FormField
                  label="Avoid Toll Roads"
                  error={fieldState.error?.message?.toString()}
                  type="checkbox"
                  inputProps={{
                    id: 'should_avoid_toll_roads',
                    ...field,
                    'data-testid': 'should_avoid_toll_roads',
                  }}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={field.value}
                />
              );
            }}
          </FormContextField>
        </div>
      </div>
    </div>
  );
}
